import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {App} from "./app/App";
import {defineCustomElements} from "@monabbous/collapsible-dashboard";

ReactDOM.render(<App/>, document.querySelector('app'));
